<template>
  <section id="df-news">
    <p class="text-justify">
      {{ $t("content") }}
    </p>
    <b-carousel :indicator-inside="false">
        <b-carousel-item >
            <img class="w100" src="@/assets/news/insurtech-latam-forum-2023-1.png" alt="hemispheric-congress-1.png">
        </b-carousel-item>
        <b-carousel-item >
            <img class="w100" src="@/assets/news/insurtech-latam-forum-2023-2.png" alt="insurtech-latam-forum-2023-2.png">
        </b-carousel-item>
        <b-carousel-item >
            <img class="w100" src="@/assets/news/insurtech-latam-forum-2023-3.png" alt="insurtech-latam-forum-2023-3.png">
        </b-carousel-item>
        
    </b-carousel>
  </section>
</template>
<script>
export default {
  name: "insurtech-latam-forum-2023"
};
</script>
<i18n>
{
    "es": {
        "title": "Estuvimos presentes en el Insurtech Latam Forum 2023",
        "content": "Insurtech Latam Forum se destaca como el único evento que integra a todo el continente, la potencia del hub Brasileño de seguros y diversos protagonistas de los países hispanohablantes. Propicia un espacio diferenciador para la generación de negocios, basados en su público de alto nivel, utilizando dinámicas de networking únicas y una agenda de contenidos de vanguardia a nivel global. Igal Neiman, Director Ejecutivo de Ceptinel, participó junto a nuestro stand recibiendo distintas visitas para conversar sobre las últimas tendencias tecnológicas en materia de prevención."
    },
    "en": {
        "title": "We were present at the Insurtech Latam Forum 2023",
        "content": "Insurtech Latam Forum stands out as the only event that integrates the entire continent, the power of the Brazilian insurance hub and various protagonists from Spanish-speaking countries. It provides a differentiating space for business generation, based on its high-level audience, using unique networking dynamics and a cutting-edge content agenda at a global level. Igal Neiman, Executive Director of Ceptinel, participated with our stand, receiving different visitors to talk about the latest technological trends in prevention."
    },
    "pt": {
        "title": "Estivemos presentes no Insurtech Latam Forum 2023",
        "content": "O Insurtech Latam Forum se destaca como o único evento que integra todo o continente, a potência do hub segurador brasileiro e diversos protagonistas dos países de língua espanhola. Promove um espaço diferenciador de geração de negócios, baseado no seu público de alto nível, utilizando dinâmicas de networking únicas e uma agenda de conteúdos de vanguarda a nível global. Igal Neiman, Diretor Executivo da Ceptinel, participou junto ao nosso stand recebendo diversas visitas para falar sobre as últimas tendências tecnológicas em prevenção."
    }
}

</i18n>
